import isNil from 'lodash/isNil';

// eslint-disable-next-line import/prefer-default-export
export const guardNullOrUndefined = data => {
  if (isNil(data)) {
    throw new Error('Specified data cant be null or undefined');
  }

  return data;
};



// WEBPACK FOOTER //
// ./app/utils/guards.js